import { render, staticRenderFns } from "./verify-identity.vue?vue&type=template&id=290dc4b7&"
import script from "./verify-identity.vue?vue&type=script&lang=ts&"
export * from "./verify-identity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports